import * as React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AuthService from '../services/auth.js';
import "../Amenities.css"

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import apiClient, { shouldRedirectToLogin } from '../services/api-client';
import AppConfig from '../services/app-config';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import ChairIcon from '@mui/icons-material/Chair';
import SearchIcon from '@mui/icons-material/Search';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import { useSwipeable } from 'react-swipeable';
import { motion, AnimatePresence } from 'framer-motion';

import PageHeader from '../components/PageHeader';

export default function Amenities({setNavbarState, navbarState}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [amenities, setAmenities] = React.useState([]);
  const [reservations, setReservations] = React.useState([]);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [tabValue, setTabValue] = React.useState('amenities'); // ['amenities', 'reservations']
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [settings,setSettings] = React.useState({});
  const apiUrl = process.env.REACT_APP_MGO_API_URL;
  const [swipeDirection, setSwipeDirection] = React.useState(null);
  const [searchValue, setSearchValue] = React.useState('');
  const [showSearch, setShowSearch] = React.useState(false);
  const searchInputRef = React.useRef(null);
  const [favoriteAmenityIds, setFavoriteAmenityIds] = React.useState(() => {
    try {
      const raw = window?.localStorage?.getItem('favoriteAmenities');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  });
  
  let snackbarmsg = new URLSearchParams(location.search).get('msg');
  let snackbarlvl = new URLSearchParams(location.search).get('lvl',"success");
  let tab = new URLSearchParams(location.search).get('tab');
  const isAdmin = AuthService.userRoleIncludes(["admin"]);

  const handleTabChange = (event,newValue) => {
    setTabValue(newValue);
    setShowSearch(false);
    setSearchValue('');
    fetchInfo(newValue);
  }

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleToggleSearch = () => {
    setShowSearch((prev) => {
      const next = !prev;
      if (!next) {
        setSearchValue('');
      }
      return next;
    });
  };

  const handleGoToRoute = (route) => {
    setRedirect({ trigger: true, route });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  function convertEpochsToTimeString(epoch1, epoch2) {
    const date1 = new Date(epoch1 * 1000);
    const date2 = new Date(epoch2 * 1000);

    const day = date1.getDate();
    const month = date1.toLocaleString('default', { month: 'short' });
    const time1 = date1.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const time2 = date2.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return `${day}/${month} ${time1} - ${time2}`;
  }

  const fetchInfo = (CurrentTabValue) => {
    setShowBackdrop(true);
    setLoading(true);

    const isAmenitiesTab = CurrentTabValue === 'amenities';
    const dayOfWeek = AppConfig.getDayOfWeek();
    const endpoint = isAmenitiesTab ? 'amenities/list' : 'reservations/list';
    const action = isAmenitiesTab ? 'fetch_amenities' : 'fetch_user_reservations';

    apiClient.get(endpoint, {}, { action })
      .then(response => {
        if (response.status === 200) {
          if (isAmenitiesTab) {
          const dataArray = Object.entries(response.data.data).map(([id, value]) => ({ id, ...value }));
          const modifiedAmenities = dataArray.map(amenity => {
            if (amenity.bloquear.length !== 0) {
              if (AppConfig.isCurrentDateInRange(amenity.bloquear.fecha_inicio, amenity.bloquear.fecha_fin)) {
                return {
                  ...amenity,
                  disponibilidad: "No Disponible",
                  bloqueado: true
                };
              }
            }
            var updatedHorarios = "No Disponible";
            for (let i = 0; i < amenity.horarios.length; i++) {
              if (amenity.horarios[i].dias.includes(dayOfWeek)) {
                updatedHorarios = `${amenity.horarios[i].hora_inicio} - ${amenity.horarios[i].hora_fin}`;
                break;
              }
            }
            return {
              ...amenity,
              disponibilidad: updatedHorarios
            };
          });
          let showTab = AuthService.userRoleIncludes(["habitante"]);
          setSettings({showTab: showTab});
          setAmenities(modifiedAmenities);
          AppConfig.storeLocal('amenities', JSON.stringify(modifiedAmenities));
          if (snackbarmsg !== null) {
            setSnackbar({ open: true, message: snackbarmsg, severity: snackbarlvl });
            setRedirect({ trigger: true, route: '/amenidades' });
            snackbarmsg = null;
          }
          }
          else if (CurrentTabValue === 'reservations') {
            console.log(response.data.data);
            const dataArray = Object.entries(response.data.data)
              .map(([id, value]) => {
                const extractedId = id.split('-')[0];
                const amenity = amenities.find(amenity => amenity.id === extractedId);
                return {
                  ...value,
                  "rango": convertEpochsToTimeString(value.inicio, value.fin),
                  
                  id,
                  amenityId: extractedId
                };
              })
              .filter(reservation => reservation.amenityId) // Filter out reservations with null amenityId
              .sort((a, b) => a.inicio - b.inicio);
            setReservations(dataArray);
          }
          setShowBackdrop(false);
          setLoading(false);
        }
      })
      .catch(error => {
        console.error('Error fetching amenities:', error);
        if (shouldRedirectToLogin(error)) {
          setRedirect({ trigger: true, route: '/login' })
        }
        setShowBackdrop(false);
        setLoading(false);
      });
  }

  React.useEffect(() => {
    setNavbarState({...navbarState, showBack: true, showOptions: false, showSearch: false})
    if (tab !== null) { 
      // setRedirect({ trigger: true, route: '/amenidades' });
      setTabValue(tab);
    }
    fetchInfo(tabValue);
  }, [tabValue]);

  React.useEffect(() => {
    if (showSearch) {
      const timeoutId = setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
      return () => clearTimeout(timeoutId);
    }
  }, [showSearch]);

  const getAmenityPaymentAmount = React.useCallback((amenity) => {
    if (!amenity) return 0;
    const raw =
      amenity?.reservacion?.monto_pago ??
      amenity?.reservacion?.monto ??
      amenity?.monto_pago ??
      amenity?.monto ??
      0;

    const num = typeof raw === 'string' ? Number(raw) : raw;
    return Number.isFinite(num) ? num : 0;
  }, []);

  const getAmenityRequirementIcons = React.useCallback((amenity) => {
    if (!amenity || amenity?.bloqueado) return [];
    const out = [];
    const paymentAmount = getAmenityPaymentAmount(amenity);
    if (amenity?.reservacion?.necesaria) out.push('reservation');
    if (paymentAmount > 0) out.push('payment');
    return out;
  }, [getAmenityPaymentAmount]);

  const toggleFavoriteAmenity = React.useCallback((amenityId) => {
    if (!amenityId) return;
    setFavoriteAmenityIds((prev) => {
      const next = prev.includes(amenityId)
        ? prev.filter((id) => id !== amenityId)
        : [amenityId, ...prev];
      try {
        window?.localStorage?.setItem('favoriteAmenities', JSON.stringify(next));
      } catch (e) {
        // ignore
      }
      return next;
    });
  }, []);

  const filteredAmenities = React.useMemo(() => {
    const q = (searchValue || '').trim().toLowerCase();
    const base = amenities.filter((amenity) => amenity?.habilitada);
    const filtered = !q ? base : base.filter((amenity) => {
      const name = (amenity?.nombre || '').toLowerCase();
      const desc = (amenity?.descripcion || '').toLowerCase();
      return name.includes(q) || desc.includes(q);
    });

    return filtered.sort((a, b) => {
      const af = favoriteAmenityIds.includes(a?.id);
      const bf = favoriteAmenityIds.includes(b?.id);
      if (af && !bf) return -1;
      if (!af && bf) return 1;
      return String(a?.nombre || '').localeCompare(String(b?.nombre || ''));
    });
  }, [amenities, searchValue, favoriteAmenityIds]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (tabValue === 'amenities' && settings.showTab) {
        setSwipeDirection('left');
        setTabValue('reservations');
      }
    },
    onSwipedRight: () => {
      if (tabValue === 'reservations' && settings.showTab) {
        setSwipeDirection('right');
        setTabValue('amenities');
      }

    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const pageVariants = {
    enter: (direction) => {
      return {
        x: direction === 'left' ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        x: direction === 'left' ? -1000 : 1000,
        opacity: 0
      };
    }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5
  };

return (
    <Container maxWidth="sm" {...swipeHandlers}>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
    <Box sx={{ mt: 1 }}>
      <Snackbar open={snackbar.open} autoHideDuration={8000} anchorOrigin={{ vertical: "top", horizontal: "center" }} sx={{mt: "3.2rem"}} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Backdrop open={showBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
          {(settings.showTab || isAdmin) && (
            <Box sx={{ position: 'sticky', top: 0, zIndex: 2, bgcolor: 'background.default', pt: 1.5, pb: 0.5 }}>
              <Box sx={{ mb: 2 }}>
                <PageHeader
                  title="Amenidades"
                  icon="swimming"
                  onBack={() => navigate(-1)}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: showSearch ? 1 : 0.5 }}>
                <Stack direction="row" spacing={1} sx={{ overflowX: 'auto', pb: 0.5, flexGrow: 1 }}>
                  <Chip
                    label="Amenidades"
                    clickable
                    color={tabValue === 'amenities' ? 'primary' : 'default'}
                    variant={tabValue === 'amenities' ? 'filled' : 'outlined'}
                    onClick={(e) => handleTabChange(e, 'amenities')}
                    sx={{ fontWeight: 700 }}
                  />
                  {!isAdmin && (
                    <Chip
                      label="Mis Reservas"
                      clickable
                      color={tabValue === 'reservations' ? 'primary' : 'default'}
                      variant={tabValue === 'reservations' ? 'filled' : 'outlined'}
                      onClick={(e) => handleTabChange(e, 'reservations')}
                      sx={{ fontWeight: 700 }}
                    />
                  )}
                  {isAdmin && (
                    <Chip
                      label="Aprobaciones"
                      clickable
                      color="default"
                      variant="outlined"
                      onClick={() => handleGoToRoute('/aprobaciones')}
                      sx={{ fontWeight: 700 }}
                    />
                  )}
                  {isAdmin && (
                    <Chip
                      label="Reservaciones"
                      clickable
                      color="default"
                      variant="outlined"
                      onClick={() => handleGoToRoute('/reservaciones')}
                      sx={{ fontWeight: 700 }}
                    />
                  )}
                </Stack>
                <IconButton
                  onClick={handleToggleSearch}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '10px',
                    border: '1px solid',
                    borderColor: 'divider',
                    color: 'text.primary',
                    display: tabValue === 'amenities' ? 'inline-flex' : 'none'
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </Box>
              {tabValue === 'amenities' && showSearch && (
                <TextField
                  fullWidth
                  size="small"
                  id="search"
                  sx={{ textAlign: 'center', mb: 0, mt: 0.5 }}
                  label="Buscar"
                  variant="outlined"
                  value={searchValue}
                  onChange={handleSearchChange}
                  inputRef={searchInputRef}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleToggleSearch}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                    style: { borderRadius: '8px' }
                  }}
                />
              )}
            </Box>
          )}
        <AnimatePresence initial={false} custom={swipeDirection}>
          <motion.div
            key={tabValue}
            custom={swipeDirection}
            variants={pageVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={pageTransition}
          >
            {tabValue === "reservations" ? (
              <>
                {!loading && (
                  reservations.length === 0 ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 150px)' }}>
                      <Card variant="outlined" sx={{ border: 0, backgroundColor: 'transparent' }} style={{ borderRadius: '10px', textAlign: 'center', width: '100%', paddingTop: '30%', paddingBottom: '40%' }}>
                        <CardContent>
                          <EventBusyIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
                          <Typography variant="h5" component="div" sx={{ mb: 2 }}><b>No tienes ninguna reservacion vigente</b></Typography>
                          <Divider />
                          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>Ve a amenidades y reserva la que desees.</Typography>
                        </CardContent>
                      </Card>
                    </Box>
                  ) : (
                    reservations.map((reservation) => (
                      <Card
                        key={reservation.id}
                        variant="outlined"
                        sx={{
                          mb: 1,
                          borderRadius: 3,
                          cursor: 'pointer',
                          '&:hover': { boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
                          transition: 'box-shadow 0.2s'
                        }}
                        onClick={() => setRedirect({route: `/reservacion?id=${reservation.id}`, trigger: true})}
                      >
                        <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
                          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                            <Box
                              component="img"
                              src={`${apiUrl}/img/amenities/${reservation.amenityId}.jpg`}
                              alt={reservation.nombre_amenidad}
                              onError={(e) => { e.target.src = '/amenityplaceholder.png'; }}
                              sx={{
                                width: 72,
                                height: 72,
                                borderRadius: 2,
                                objectFit: 'cover',
                                flexShrink: 0,
                                backgroundColor: '#f0f0f0'
                              }}
                            />
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                variant="body1"
                                sx={{ fontWeight: 700, lineHeight: 1.3, mb: 0.25 }}
                                noWrap
                              >
                                {reservation.nombre_amenidad}
                              </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.25 }}>
                                <AccessTimeIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                                <Typography variant="caption" color="text.secondary" noWrap>
                                  {reservation.rango}
                                </Typography>
                              </Box>

                              {reservation.confirmada ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                                  <CheckCircleOutlineIcon sx={{ fontSize: '0.95rem', color: 'success.main' }} />
                                  <Typography variant="caption" color="success.main" sx={{ fontWeight: 600 }}>
                                    Confirmada
                                  </Typography>
                                </Box>
                              ) : (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                                  <EventBusyIcon sx={{ fontSize: '0.95rem', color: 'warning.main' }} />
                                  <Typography variant="caption" color="warning.main" sx={{ fontWeight: 600 }}>
                                    Pendiente de confirmacion
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    )) 
                  )
                )}
              </>
            ) : (
              <>
                {!loading && (
                  filteredAmenities.length === 0 ? (

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 150px)' }}>
                    <Card variant="outlined" sx={{ border: 0, backgroundColor: 'transparent' }} style={{ borderRadius: '10px', textAlign: 'center', width: '100%', paddingTop: '30%', paddingBottom: '40%' }}>
                      <CardContent>
                        <ChairIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
                        <Typography variant="h5" component="div" sx={{ mb: 2 }}><b>No hay amenidades disponibles</b></Typography>
                        <Divider />
                        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>Intenta mas tarde o contacta al administrador.</Typography>
                      </CardContent>
                    </Card>
                  </Box>
                  ) : (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                        gap: 2,
                        pb: 10
                      }}
                    >
                      {filteredAmenities.map((amenity) => {
                        const imageUrl = `${apiUrl}/img/amenities/${amenity.id}.jpg`;
                        const isFavorited = favoriteAmenityIds.includes(amenity.id);
                        const requirementIcons = getAmenityRequirementIcons(amenity);
                        return (
                          <Box key={amenity.id} sx={{ cursor: 'pointer' }}>
                            <Box
                              onClick={() => setRedirect({ trigger: true, route: `/amenidad?id=${amenity.id}` })}
                              sx={{
                                position: 'relative',
                                borderRadius: '18px',
                                overflow: 'hidden',
                                height: 148,
                                boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                                transform: 'translateZ(0)',
                                '&:active': { transform: 'scale(0.99)' },
                              }}
                            >
                              <Box
                                component="img"
                                src={imageUrl}
                                onError={(e) => { e.target.src = '/amenityplaceholder.png'; }}
                                sx={{
                                  position: 'absolute',
                                  inset: 0,
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />

                              {requirementIcons.length > 0 && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 10,
                                    left: 10,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: '999px',
                                    backgroundColor: 'rgba(255,255,255,0.92)',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.10)',
                                  }}
                                >
                                  {requirementIcons.includes('reservation') && (
                                    <CalendarMonthIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                                  )}
                                  {requirementIcons.includes('payment') && (
                                    <AttachMoneyIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                                  )}
                                </Box>
                              )}

                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleFavoriteAmenity(amenity.id);
                                }}
                                sx={{
                                  position: 'absolute',
                                  top: 6,
                                  right: 6,
                                  width: 40,
                                  height: 40,
                                  color: isFavorited ? '#E31B23' : '#fff',
                                  backgroundColor: isFavorited ? 'rgba(255,255,255,0.90)' : 'rgba(0,0,0,0.12)',
                                  backdropFilter: 'blur(6px)',
                                  '&:hover': {
                                    backgroundColor: isFavorited ? 'rgba(255,255,255,0.92)' : 'rgba(0,0,0,0.18)'
                                  }
                                }}
                              >
                                {isFavorited ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                              </IconButton>
                            </Box>

                            <Box sx={{ mt: 1 }}>
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 800, color: 'text.primary', lineHeight: 1.15 }}
                                noWrap
                              >
                                {amenity.nombre}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ color: 'text.secondary', display: 'block' }}
                                noWrap
                              >
                                {amenity.descripcion}
                              </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.75, color: 'text.secondary' }}>
                                <AccessTimeIcon sx={{ fontSize: 16 }} />
                                {amenity.disponibilidad !== 'No Disponible' ? (
                                  <Typography variant="caption" sx={{ fontWeight: 600 }} noWrap>
                                    {amenity.disponibilidad}
                                  </Typography>
                                ) : (
                                  <Typography variant="caption" sx={{ fontWeight: 700 }} noWrap>
                                    No disponible hoy
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  )
                )}
              </>
            )}
          </motion.div>
        </AnimatePresence>
      
    </Box>
    </Container>
  );
}